/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreCommonExcelExportExcelRequest,
  FacilityFlowCoreCommonExcelImportResultDto,
  FacilityFlowCoreModulesEmployeesDtosAssignWorkScheduleModelRequest,
  FacilityFlowCoreModulesEmployeesDtosAssignWorkScheduleModelResponse,
  FacilityFlowCoreModulesEmployeesDtosChangePasswordRequest,
  FacilityFlowCoreModulesEmployeesDtosCreateEmployeeRequest,
  FacilityFlowCoreModulesEmployeesDtosCreateEmployeeResponse,
  FacilityFlowCoreModulesEmployeesDtosEmployeeDto,
  FacilityFlowCoreModulesEmployeesDtosResetPasswordRequest,
  FacilityFlowCoreModulesEmployeesDtosSearchEmployeesResponse,
  FacilityFlowCoreModulesEmployeesDtosUpdateEmployeeRequest,
  FacilityFlowCoreModulesEmployeesDtosUpdateEmployeeResponse,
  FacilityFlowCoreModulesEmployeesDtosUpdateOwnProfileRequest,
  GetApiV1EmployeesParams,
  PostApiV1EmployeesIdTerminateParams,
  PostApiV1EmployeesImportExcelBody,
  PostApiV1EmployeesImportExcelParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getEmployees = () => {
/**
 * @summary Search employees with optional filters
 */
const getApiV1Employees = (
    params?: GetApiV1EmployeesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesEmployeesDtosSearchEmployeesResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesEmployeesDtosSearchEmployeesResponse>(
      {url: `/api/v1/employees`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a new employee
 */
const postApiV1Employees = (
    facilityFlowCoreModulesEmployeesDtosCreateEmployeeRequest: FacilityFlowCoreModulesEmployeesDtosCreateEmployeeRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesEmployeesDtosCreateEmployeeResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesEmployeesDtosCreateEmployeeResponse>(
      {url: `/api/v1/employees`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesEmployeesDtosCreateEmployeeRequest
    },
      options);
    }
  /**
 * @summary Get employee by ID
 */
const getApiV1EmployeesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesEmployeesDtosEmployeeDto>>,) => {
      return customInstance<FacilityFlowCoreModulesEmployeesDtosEmployeeDto>(
      {url: `/api/v1/employees/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing employee (admin only)
 */
const putApiV1EmployeesId = (
    id: string,
    facilityFlowCoreModulesEmployeesDtosUpdateEmployeeRequest: FacilityFlowCoreModulesEmployeesDtosUpdateEmployeeRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesEmployeesDtosUpdateEmployeeResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesEmployeesDtosUpdateEmployeeResponse>(
      {url: `/api/v1/employees/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesEmployeesDtosUpdateEmployeeRequest
    },
      options);
    }
  /**
 * @summary Delete an employee
 */
const deleteApiV1EmployeesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/employees/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Assign or clear an employee's work schedule model (admin only).
Assigning regenerates the next 90 days of WorkDay planning entries;
clearing leaves existing entries untouched.
 */
const putApiV1EmployeesIdWorkScheduleModel = (
    id: string,
    facilityFlowCoreModulesEmployeesDtosAssignWorkScheduleModelRequest: FacilityFlowCoreModulesEmployeesDtosAssignWorkScheduleModelRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesEmployeesDtosAssignWorkScheduleModelResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesEmployeesDtosAssignWorkScheduleModelResponse>(
      {url: `/api/v1/employees/${id}/work-schedule-model`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesEmployeesDtosAssignWorkScheduleModelRequest
    },
      options);
    }
  /**
 * @summary Download all employees as an Excel workbook. Contains no passwords.
 */
const postApiV1EmployeesExportExcel = (
    facilityFlowCoreCommonExcelExportExcelRequest: FacilityFlowCoreCommonExcelExportExcelRequest,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/employees/export/excel`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreCommonExcelExportExcelRequest,
        responseType: 'blob'
    },
      options);
    }
  /**
 * A committing run returns the one-time passwords of the accounts it created in
`credentials`. They exist only in that response — hand them over and discard.
 * @summary Import an edited employee workbook. With `dryRun=true` (the default) the
response is a preview and nothing is written.
 */
const postApiV1EmployeesImportExcel = (
    postApiV1EmployeesImportExcelBody: PostApiV1EmployeesImportExcelBody,
    params?: PostApiV1EmployeesImportExcelParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreCommonExcelImportResultDto>>,) => {const formData = new FormData();
if(postApiV1EmployeesImportExcelBody.file !== undefined) {
 formData.append(`file`, postApiV1EmployeesImportExcelBody.file)
 }
if(postApiV1EmployeesImportExcelBody.excludeRows !== undefined) {
 postApiV1EmployeesImportExcelBody.excludeRows.forEach(value => formData.append(`excludeRows`, value));
 }

      return customInstance<FacilityFlowCoreCommonExcelImportResultDto>(
      {url: `/api/v1/employees/import/excel`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params
    },
      options);
    }
  /**
 * @summary Update own profile (self-service)
 */
const putApiV1EmployeesMeProfile = (
    facilityFlowCoreModulesEmployeesDtosUpdateOwnProfileRequest: FacilityFlowCoreModulesEmployeesDtosUpdateOwnProfileRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesEmployeesDtosEmployeeDto>>,) => {
      return customInstance<FacilityFlowCoreModulesEmployeesDtosEmployeeDto>(
      {url: `/api/v1/employees/me/profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesEmployeesDtosUpdateOwnProfileRequest
    },
      options);
    }
  /**
 * @summary Change own password
 */
const postApiV1EmployeesMeChangePassword = (
    facilityFlowCoreModulesEmployeesDtosChangePasswordRequest: FacilityFlowCoreModulesEmployeesDtosChangePasswordRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/employees/me/change-password`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesEmployeesDtosChangePasswordRequest
    },
      options);
    }
  /**
 * @summary Reset employee password (admin only)
 */
const postApiV1EmployeesIdResetPassword = (
    id: string,
    facilityFlowCoreModulesEmployeesDtosResetPasswordRequest: FacilityFlowCoreModulesEmployeesDtosResetPasswordRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/employees/${id}/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesEmployeesDtosResetPasswordRequest
    },
      options);
    }
  /**
 * @summary Activate an employee
 */
const postApiV1EmployeesIdActivate = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/employees/${id}/activate`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Deactivate an employee
 */
const postApiV1EmployeesIdDeactivate = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/employees/${id}/deactivate`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Terminate an employee
 */
const postApiV1EmployeesIdTerminate = (
    id: string,
    params?: PostApiV1EmployeesIdTerminateParams,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/employees/${id}/terminate`, method: 'POST',
        params
    },
      options);
    }
  return {getApiV1Employees,postApiV1Employees,getApiV1EmployeesId,putApiV1EmployeesId,deleteApiV1EmployeesId,putApiV1EmployeesIdWorkScheduleModel,postApiV1EmployeesExportExcel,postApiV1EmployeesImportExcel,putApiV1EmployeesMeProfile,postApiV1EmployeesMeChangePassword,postApiV1EmployeesIdResetPassword,postApiV1EmployeesIdActivate,postApiV1EmployeesIdDeactivate,postApiV1EmployeesIdTerminate}};
export type GetApiV1EmployeesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['getApiV1Employees']>>>
export type PostApiV1EmployeesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['postApiV1Employees']>>>
export type GetApiV1EmployeesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['getApiV1EmployeesId']>>>
export type PutApiV1EmployeesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['putApiV1EmployeesId']>>>
export type DeleteApiV1EmployeesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['deleteApiV1EmployeesId']>>>
export type PutApiV1EmployeesIdWorkScheduleModelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['putApiV1EmployeesIdWorkScheduleModel']>>>
export type PostApiV1EmployeesExportExcelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['postApiV1EmployeesExportExcel']>>>
export type PostApiV1EmployeesImportExcelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['postApiV1EmployeesImportExcel']>>>
export type PutApiV1EmployeesMeProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['putApiV1EmployeesMeProfile']>>>
export type PostApiV1EmployeesMeChangePasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['postApiV1EmployeesMeChangePassword']>>>
export type PostApiV1EmployeesIdResetPasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['postApiV1EmployeesIdResetPassword']>>>
export type PostApiV1EmployeesIdActivateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['postApiV1EmployeesIdActivate']>>>
export type PostApiV1EmployeesIdDeactivateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['postApiV1EmployeesIdDeactivate']>>>
export type PostApiV1EmployeesIdTerminateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployees>['postApiV1EmployeesIdTerminate']>>>
